export type RedactToken = { text: string; sensitive: boolean; conceptId: string };
export type RedactRound = { context: string; tokens: RedactToken[] };

const S = "scene_safety";
const B = "bleeding_basic";
const E = "emergency_call";
const R = "recovery_position";

export const FIRST_AID_REDACT_DECK: readonly RedactRound[] = [
  {
    context: "Text to a neighbour about a fall on the pavement:",
    tokens: [
      { text: "Hi", sensitive: false, conceptId: E },
      { text: "I’m at", sensitive: false, conceptId: E },
      { text: "742 Evergreen Terrace, front steps", sensitive: true, conceptId: E },
      { text: "elderly person fell, awake, arm bleeding", sensitive: true, conceptId: B },
      { text: "called", sensitive: false, conceptId: E },
      { text: "112", sensitive: false, conceptId: E },
    ],
  },
  {
    context: "Draft post (do NOT post in real emergencies):",
    tokens: [
      { text: "Training only:", sensitive: false, conceptId: S },
      { text: "check traffic", sensitive: false, conceptId: S },
      { text: "before moving someone from the road", sensitive: false, conceptId: S },
    ],
  },
  {
    context: "Support message to a friend learning first aid:",
    tokens: [
      { text: "Recovery position is for", sensitive: false, conceptId: R },
      { text: "unconscious breathing", sensitive: false, conceptId: R },
      { text: "when your course says it’s OK", sensitive: false, conceptId: R },
    ],
  },
  {
    context: "Voice note script to emergency line:",
    tokens: [
      { text: "I need an ambulance at", sensitive: false, conceptId: E },
      { text: "corner of Oak and 3rd", sensitive: true, conceptId: E },
      { text: "person collapsed, breathing shallow", sensitive: true, conceptId: R },
    ],
  },
  {
    context: "Checklist before bandaging in a class exercise:",
    tokens: [
      { text: "Gloves if available", sensitive: false, conceptId: B },
      { text: "Direct pressure", sensitive: false, conceptId: B },
      { text: "Patient’s NHS number", sensitive: true, conceptId: B },
    ],
  },
  {
    context: "Reminder card in a workshop:",
    tokens: [
      { text: "If the scene is unsafe,", sensitive: false, conceptId: S },
      { text: "do not rush in", sensitive: false, conceptId: S },
      { text: "call for help from a safe spot", sensitive: false, conceptId: E },
    ],
  },
];
